import React from 'react';
import { ApiAttributeMapping, ApiSanctionEntity, ApiSanctionEntityType } from '../api';
import { Popover } from 'react-bootstrap';
import { getPersonDisplayName } from '../common/helper';
import { formatAmount } from '../schema/helper';
import RmsPopover from '../common/popover/RmsPopover';
import TransactionAttributes from '../transaction/TransactionAttributes';
import PersonAttributes from '../aml/sections/PersonAttributes';
import { InternalApiCurrentUserOrganisationCurrencyEnum } from '../api-internal';

interface Props {
  entity: ApiSanctionEntity;
  mappings: { [key: string]: ApiAttributeMapping };
  organisationCurrency?: InternalApiCurrentUserOrganisationCurrencyEnum;
}

const ScreeningEntityDetails = ({ entity, mappings, organisationCurrency }: Props) => {
  const isPerson = entity.entityType === ApiSanctionEntityType.PERSON;
  const { person, transaction }: ApiSanctionEntity = entity;

  const personDetailsPopover = () => (
    <Popover id='person-details-popover'>
      <Popover.Body>{person && <PersonAttributes person={person} />}</Popover.Body>
    </Popover>
  );

  const transactionDetailsPopover = () => (
    <Popover id='transaction-details-popover' data-testid='transaction-details-popover'>
      <Popover.Body>
        {transaction && (
          <TransactionAttributes
            transaction={transaction}
            showLinkToTransactionPage={false}
            showLinkToCustomerPage={false}
            showId={true}
          />
        )}
      </Popover.Body>
    </Popover>
  );

  const displayEntityDescription = () => {
    return isPerson
      ? person && person.attributes && getPersonDisplayName(person, mappings)
      : transaction && transaction.id;
  };

  const displayAdditionalEntityDetails = () => {
    return isPerson
      ? ''
      : transaction && ` • ${formatAmount(parseFloat(transaction.attributes?.amount || '0'), organisationCurrency)}`;
  };

  return (
    <>
      <RmsPopover overlay={isPerson ? personDetailsPopover() : transactionDetailsPopover()}>
        <span className='hover-link'>
          {entity.entityType}: {displayEntityDescription()}
        </span>
      </RmsPopover>
      {displayAdditionalEntityDetails()}
    </>
  );
};

export default ScreeningEntityDetails;
